import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const unorderedListBlockSchema = z.object({
	items: z.object({ id: z.string().uuid(), text: nonEmptyString }).array(),
});
